/* eslint-disable ember/no-mixins */
import PaperRadioGroupBase from 'ember-paper/components/paper-radio-group';
import ValidationMixin from 'ember-paper/mixins/validation-mixin';
import { and } from '@ember/object/computed';

export default class PaperRadioGroup extends PaperRadioGroupBase.extend(
  ValidationMixin,
) {
  tagName = 'md-input-container';
  tabindex = -1;

  // Tell ValidationMixin what to validate on.
  validationProperty = 'groupValue';

  // Mark field as invalid only if also touched. Computed (not a plain getter)
  // so the `md-input-invalid` classNameBinding re-evaluates when either
  // dependency changes.
  @and('isInvalid', 'isTouched') isInvalidAndTouched;

  classNameBindings = [
    'isInvalidAndTouched:md-input-invalid',
    'focused:md-input-focused',
  ];

  // Force label to render in the correct position.
  classNames = ['md-input-has-value'];

  // Register with the parent form when one is supplied, matching ember-paper's
  // built-in fields. ember-paper 1.0 removed ChildMixin and its `nearestOfType`
  // auto-discovery, so the form must be passed in explicitly:
  // `@parentComponent={{form.parentComponent}}`. The radios register with this
  // group, not the form.
  didInsertElement() {
    super.didInsertElement(...arguments);
    if (this.parentComponent) {
      this.parentComponent.register(this);
    }
  }

  willDestroyElement() {
    super.willDestroyElement(...arguments);
    if (this.parentComponent) {
      this.parentComponent.deRegister(this);
    }
  }
}
